import {
  ChannelsIcon,
  DashboardIcon,
  HashtagsIcon,
  InfluencersIcon,
  NewsIcon,
  OrganizationsIcon,
  PostsIcon,
  ReportsIcon,
  SetsIcon,
  SettingIcon,
  TrendsIcon,
  TweetsSidBarIcon,
  UsersIcon,
  VideoSidebarIcon,
} from 'app/assets/images/icons';
import { path } from 'app/utils/path';
import React, { FunctionComponent } from 'react';
import { JsxElement } from 'typescript';

type title = { ar: string; en: string };
export type firstLevelSideMenuItem = {
  module: string;
  newTitle?: title | null;
  title: title;
  id: string;
  order?: number;
  menuItems?: sideMenuItem[];
  icon: JsxElement;
};
export type sideMenuItem = {
  link: string;
  newTitle?: title | null;
  item: title;
  id: string;
  order: number;
  menuItems?: any[];
};
// sidemenu initial state
export const addordertosidemenu: (list: any[]) => any[] = (list) => {
  const orderedsidemenuitems = list?.map((firstlevelitem: any, i) => {
    if (firstlevelitem.menuItems) {
      return {
        ...firstlevelitem,
        order: i,
        menuItems: firstlevelitem.menuItems.map(
          (secondlevelitem: any, j: number) => {
            if (secondlevelitem.subMenu) {
              return {
                ...secondlevelitem,
                order: j,
                subMenu: secondlevelitem.subMenu.map(
                  (thirdlevelitem: any, x: number) => ({
                    ...thirdlevelitem,
                    order: x,
                    id: `${firstlevelitem.id}-${thirdlevelitem.link}`,
                  }),
                ),
              };
            }
            return {
              ...secondlevelitem,
              order: i,
            };
          },
        ),
      };
    } else {
      return { ...firstlevelitem, order: i };
    }
  });
  return orderedsidemenuitems;
};

export const sideBarItems: any = [
  // Trends
  {
    module: 'TRENDS',
    title: { ar: 'الترندات', en: 'trends' },
    id: 'sidebar_trends',
    icon: <TrendsIcon />,
    order: 1,
    menuItems: [
      {
        item: { ar: 'قائمة رئيسية', en: 'Dashboard' },
        link: path.trends.ALL,
        order: 1,
        id: 'trendsdash',
      },
      {
        item: { ar: 'الهاشتاقات', en: 'hashtags' },
        order: 2,
        id: 'trendshash',
        subMenu: [
          {
            item: {
              ar: 'جدول الهاشتاقات الترند',
              en: 'trending hashtags table',
            },
            link: path.trends.HASHTAGS,
            order: 1,
          },
          {
            item: { ar: 'الهاشتاقات الترند ٢٤', en: 'hashtags trending 24' },
            link: path.trends.TRENDING_COMPARE,
            order: 2,
          },
          {
            item: {
              ar: 'اخر 5 ساعات هاشتاقات ترند',
              en: 'Last 5 H Trending Hashtags',
            },
            link: path.trends.LAST_FIVE_TRENDING_HASHTAGS,
            order: 3,
          },
        ],
      },
      {
        item: {
          ar: 'الأخبار',
          en: 'News ',
        },
        link: path.trends.NEWS,
        id: 'trendsnews',
        order: 3,
      },
      {
        item: {
          ar: 'الفيديوهات',
          en: 'videos ',
        },
        order: 4,
        id: 'trendsvideos',
        subMenu: [
          {
            item: {
              ar: 'جدول الفيديوهات الترند',
              en: 'trending videos table',
            },
            link: path.trends.VIDEOS,
            order: 1,
          },
          {
            item: {
              ar: 'مقارنة الفيديوهات',
              en: 'compare videos',
            },
            link: path.trends.COMPARE_VIDEOS,
            order: 2,
          },
        ],
      },
      {
        item: {
          ar: 'الموضوعات',
          en: 'Topics',
        },
        order: 5,
        id: 'trendstopics',
        subMenu: [
          {
            item: {
              ar: 'جدول الموضوعات الترند',
              en: 'trending topics table',
            },
            link: path.trends.TOPICS,
            order: 1,
          },
          {
            item: {
              ar: 'مقارنة الموضوعات',
              en: 'Compare Topics',
            },
            link: path.trends.COMPARE_TOPICS,
            order: 2,
          },
        ],
      },
    ],
  },

  // Hashtags
  {
    module: 'HASHTAGS',
    title: { ar: 'الهاشتاقات', en: 'hashtags' },
    id: 'sidebar_hashtags',
    icon: <HashtagsIcon />,
    order: 1,

    menuItems: [
      {
        item: { ar: 'قائمة رئيسية', en: 'Dashboard' },
        link: path.hashtags.DASHBOARD,
        order: 1,
        id: 'hashdash',
      },
      {
        item: {
          ar: 'جدول الهاشتاقات',
          en: 'hashtags table',
        },
        link: path.hashtags.HASHTAGS,
        order: 2,
        id: 'hashhash',
      },
      {
        item: {
          ar: 'مقارنة الهاشتاقات',
          en: 'compare hashtags',
        },
        link: path.hashtags.COMPARE_HASHTAGS,
        order: 3,
        id: 'hashcompare',
      },
    ],
  },
  //tweets
  {
    module: 'TWEETS',
    title: {
      ar: 'التغريدات',
      en: 'Tweets',
    },
    id: 'sidebar_tweets',
    icon: <TweetsSidBarIcon />,
    menuItems: [
      {
        item: { ar: 'قائمة رئيسية', en: 'Dashboard' },
        link: path.tweets.DASHBOARD,
        order: 1,
        id: 'tweets_dashboard',
      },
      {
        item: { ar: 'جدول التغريدات', en: 'tweets table' },
        link: path.tweets.TWEETS_TABLE,
        order: 2,
        id: 'tweets_table',
      },
    ],
  },

  // Sets
  {
    module: 'SETS',
    title: {
      ar: 'مجموعات',
      en: 'sets',
    },
    id: 'sidebar_sets',
    icon: <SetsIcon />,
    order: 1,
    menuItems: [
      {
        item: { ar: 'قائمة رئيسية', en: 'Dashboard' },
        link: path.sets.DASHBOARD,
        order: 1,
        id: 'setsdash',
      },
      {
        item: { ar: 'جدول المجموعات', en: 'Sets Table' },
        link: path.sets.SETS_TABLE,
        order: 2,
        id: 'setssets',
      },
    ],
  },

  // Videos
  {
    module: 'VIDEOS',
    title: {
      ar: 'الفيديوهات',
      en: 'videos',
    },
    id: 'sidebar_videos',
    icon: <VideoSidebarIcon />,
    order: 1,

    menuItems: [
      {
        item: { ar: 'قائمة رئيسية', en: 'Dashboard' },
        link: path.videos.DASHBOARD,
        order: 1,
        id: 'videodash',
      },
      {
        item: { ar: 'جدول الفيديوهات', en: 'videos Table' },
        link: path.videos.VIDEOS_TABLE,
        order: 2,
        id: 'videovideo',
      },
      {
        item: {
          ar: 'مقارنة الفيديوهات',
          en: 'compare videos',
        },
        link: path.videos.COMPARE_VIDEOS,
        order: 3,
        id: 'videocompare',
      },
    ],
  },

  // Influencers
  {
    module: 'INFLUENCERS',
    title: { ar: 'المؤثرون', en: 'influencers' },
    id: 'sidebar_influencers',
    icon: <InfluencersIcon />,
    order: 1,
    menuItems: [
      {
        item: { ar: 'قائمة رئيسية', en: 'Dashboard' },
        link: path.influencers.ALL,
        id: 'infdash',
      },
      {
        item: { ar: 'جدول المؤثرون', en: 'influencers Table' },
        link: path.influencers.INFLUENCERS,
        id: 'infinf',
      },
      {
        item: {
          ar: 'المجموعات',
          en: 'groups ',
        },
        link: path.influencers.INFLUENCERS_GROUP,
        id: 'infgroup',
      },
      {
        item: {
          ar: 'الفئات',
          en: 'categories',
        },
        link: path.influencers.INFLUENCERS_CATEGORIES,
        id: 'infcategory',
      },
    ],
  },

  // Entities
  {
    module: 'ENTITIES',
    title: {
      ar: 'الكيانات',
      en: 'entities',
    },
    id: 'sidebar_entities',
    icon: <ChannelsIcon />,
    menuItems: [
      {
        item: { ar: 'قائمة رئيسية', en: 'Dashboard' },
        link: path.entities.ALL,
        id: 'entitydash',
      },
      {
        item: { ar: 'جدول الكيانات', en: 'entities Table' },
        link: path.entities.ENTITIES,
        id: 'entityentity',
      },
      {
        item: {
          ar: 'المجموعات',
          en: 'groups',
        },
        link: path.entities.ENTITIES_GROUP,
        id: 'entitygroups',
      },
      {
        item: {
          ar: 'الفئات',
          en: 'categories',
        },
        link: path.entities.ENTITIES_CATEGORIES,
        id: 'entitycategories',
      },
    ],
  },

  // News
  {
    module: 'NEWS',
    title: {
      ar: 'الأخبار',
      en: 'News',
    },
    id: 'sidebar_news',
    icon: <NewsIcon />,
    menuItems: [
      {
        item: { ar: 'قائمة رئيسية', en: 'Dashboard' },
        link: path.news.DASHBOARD,
        id: 'newsdash',
      },
      {
        item: { ar: 'جدول الأخبار', en: 'News Table' },
        link: path.news.NEWS_TABLE,
        id: 'newstable',
      },
      {
        item: { ar: 'جدول كُتَّاب الرأي', en: 'authors Table' },
        link: path.news.AUTHORS_TABLE,
        id: 'newsauthor',
      },
      {
        item: { ar: 'جدول المحررين', en: 'editors Table' },
        id: 'newseditor',
        link: path.news.EDITOR_TABLE,
      },
      {
        item: {
          ar: 'الفئات',
          en: 'categories ',
        },
        link: path.news.CATEGORIES_TABLE,
        id: 'newscategories',
      },
      {
        item: { ar: 'جدول المصادر', en: 'sources Table' },
        link: path.news.SOURCES_TABLE,
        id: 'newssources',
      },
      {
        item: { ar: 'جدول الوسوم', en: 'tags Table' },
        link: path.news.TAGS_TABLE,
        id: 'newstags',
      },
    ],
  },

  // Topics
  {
    module: 'TOPICS',
    title: { ar: 'الموضوعات', en: 'Topics' },
    id: 'sidebar_topics',
    icon: <NewsIcon />,
    menuItems: [
      {
        item: { ar: 'قائمة رئيسية', en: 'Dashboard' },
        link: path.topics.DASHBOARD,
        id: 'topicdash',
      },
      {
        item: { ar: 'جدول الموضوعات', en: 'Topics Table' },
        link: path.topics.TOPICS_TABLE,
        id: 'topictopic',
      },
      {
        item: {
          ar: 'مقارنة الموضوعات',
          en: 'compare Topics',
        },
        link: path.topics.COMPARE_TOPICS,
        id: 'topiccompare',
      },
      {
        item: {
          ar: 'الفئات',
          en: 'categories ',
        },
        link: path.topics.CATEGORIES_TABLE,
        id: 'topiccategories',
      },
    ],
  },

  // ORGANIZATION
  {
    module: 'ORGANIZATIONS',
    title: {
      ar: 'المؤسسات',
      en: 'organizations',
    },
    id: 'sidebar_organizations',
    icon: <OrganizationsIcon />,
    menuItems: [
      {
        item: {
          ar: 'جدول المؤسسات',
          en: 'organizations table',
        },
        link: path.organization.ORGANIZATION_TABLE,
        id: 'orgorg',
      },
    ],
  },

  // System
  // {
  //   module: 'SYSTEM',
  //   title: {
  //     ar: 'النظام',
  //     en: 'System',
  //   },
  //   id: 'sidebar_system',
  //   icon: <SystemIcon />,
  //   menuItems: [
  //     {
  //       item: {
  //         ar: 'النظام',
  //         en: 'System',
  //       },
  //       link: '/dashboard',
  //       id: 'syssys',
  //     },
  //   ],
  // },

  // Reports
  {
    module: 'REPORTS',
    title: {
      ar: 'تقارير',
      en: 'Reports ',
    },
    id: 'sidebar_reports',
    icon: <ReportsIcon />,
    menuItems: [
      {
        item: {
          ar: 'قوالب الهاشتاق',
          en: 'HASHTAG TEMPLATES',
        },
        link: path.reports.HASHTAGS_TEMPLATES,
        order: 1,
        id: 'reporthash',
      },
      {
        item: {
          ar: 'قوالب الفيديوهات',
          en: ' VIDEOS TEMPLATES',
        },
        link: path.reports.VIDEOS_TEMPLATES,
        order: 2,
        id: 'reportvideo',
      },
      {
        item: {
          ar: 'قوالب المؤثرون',
          en: ' INFLUENCERS TEMPLATES',
        },
        link: path.reports.INFLUENCERS_TEMPLATES,
        order: 2,
        id: 'reportinfluencers',
      },
      {
        item: {
          ar: 'قوالب الكيانات',
          en: ' ENTITIES TEMPLATES',
        },
        link: path.reports.ENTITIES_TEMPLATES,
        order: 2,
        id: 'reportentities',
      },
      {
        item: {
          ar: 'قوالب الأخبار',
          en: ' News Templates',
        },
        link: path.reports.NEWS_TEMPLATES,
        order: 2,
        id: 'reportnews',
      },
      {
        item: {
          ar: 'قوالب التغريدات',
          en: ' Tweets Templates',
        },
        link: path.reports.TWEETS_TEMPLATES,
        order: 2,
        id: 'reporttweets',
      },
      {
        item: {
          ar: 'قوالب منشورات يوتيوب',
          en: 'Youtube Posts Templates',
        },
        link: path.reports.YOUTUBE_POSTS_TEMPLATES,
        order: 2,
        id: 'reportyoutubeposts',
      },
      {
        item: {
          ar: 'قوالب منشورات الانستقرام',
          en: 'Instagram Posts Templates',
        },
        link: path.reports.INSTAGRAM_POSTS_TEMPLATES,
        order: 2,
        id: 'reportinstagramposts',
      },
      {
        item: {
          ar: 'قوالب منشورات التيك توك',
          en: 'Tiktok Posts Templates',
        },
        link: path.reports.TIK_TOK_POSTS_TEMPLATES,
        order: 2,
        id: 'reporttiktokposts',
      },
      {
        item: {
          ar: 'قوالب منشورات لينكد ان',
          en: 'Linkedin Posts Templates',
        },
        link: path.reports.LINKEDIN_POSTS_TEMPLATES,
        order: 2,
        id: 'reportlinkedinposts',
      },
    ],
  },

  //archive
  {
    module: 'ARCHIVE',
    title: {
      ar: 'ارشيف',
      en: 'archive',
    },
    id: 'sidebar_archive',
    icon: <ReportsIcon />,
    menuItems: [
      {
        item: { ar: 'قائمة رئيسية', en: 'Dashboard' },
        link: path.archive.DASHBOARD,
        order: 1,
        id: 'archive_dashboard',
      },
      {
        item: { ar: 'جدول الارشيف', en: 'items table' },
        link: path.archive.ITEMS_TABLE,
        order: 2,
        id: 'archive_items_table',
      },
      {
        item: {
          ar: 'الفئات',
          en: 'categories ',
        },
        link: path.archive.CATEGORIES,
        order: 3,
        id: 'archive_categories',
      },
      {
        item: { ar: 'جدول الكلمات المفتاحية', en: 'tags table' },
        link: path.archive.TAGS_TABLE,
        order: 4,
        id: 'archive_tags_table',
      },
      {
        item: { ar: 'المجموعات', en: 'groups' },
        link: path.archive.GROUPS_TABLE,
        order: 5,
        id: 'archive_groups_table',
      },
    ],
  },

  // Users
  {
    module: 'USERS',
    title: {
      ar: 'المستخدمون',
      en: 'Users',
    },
    id: 'sidebar_users',
    icon: <UsersIcon />,
    order: 1,
    menuItems: [
      {
        item: { ar: 'قائمة رئيسية', en: 'Dashboard' },
        link: path.users.DASHBOARD,
        order: 1,
        id: 'usersdash',
      },
      {
        item: { ar: 'جدول المستخدمون', en: 'Users Table' },
        link: path.users.USERS_TABLE,
        order: 2,
        id: 'usersuser',
      },
      {
        item: { ar: 'أنشطة المستخدم', en: "user's activities" },
        link: path.users.USER_ACTIVTIES,
        order: 3,
        id: 'usersactivites',
      },
      {
        item: { ar: 'مجموعات الصلاحيات', en: 'permission groups' },
        link: path.users.PERMISSION_GROUPS,
        order: 4,
        id: 'usersgroups',
      },
    ],
  },
  //settings
  {
    module: 'SETTINGS',
    title: {
      ar: 'الإعدادات',
      en: 'settings',
    },
    id: 'sidebar_settings',
    icon: <SettingIcon />,
    menuItems: [
      {
        item: { ar: ' النظام ', en: 'System ' },
        link: path.settings.USER_SETTINGS,
        order: 1,
        id: 'systemsetting',
      },
      {
        item: { ar: ' الإشعارات ', en: 'Notifications ' },
        link: path.settings.NOTIFICATIONS_SETTINGS,
        order: 2,
        id: 'notificationsetting',
      },
    ],
  },
  {
    module: 'ADMIN',
    id: 'sidebar_admin',
    icon: <UsersIcon />,
    title: {
      ar: 'الأدمن',
      en: 'Admin',
    },
    order: 15,
    menuItems: [
      {
        item: {
          ar: 'قائمة رئيسية',
          en: 'Dashboard',
        },
        link: path.admin.DASHBOARD,
        order: 1,
        id: 'admin_dashboard',
      },
      {
        item: {
          ar: 'جدول المصادر',
          en: 'headless sources table',
        },
        link: path.admin.SOURCE_TABLE,
        order: 2,
        id: 'sources_table',
      },
      {
        item: {
          ar: '',
          en: 'Elasticsearch Indexes',
        },
        link: path.admin.ELASTICSEARCH_INDEXES,
        order: 3,
        id: 'elasticsearch_indexes',
      },
      {
        item: {
          ar: 'جدول المصادر',
          en: 'News Logs Table',
        },
        link: path.admin.NEWS,
        order: 4,
        id: 'news_source_log_table',
      },
    ],
  },
  //Posts
  {
    module: 'POSTS',
    title: { ar: 'المنشورات', en: 'posts' },
    id: 'sidebar_posts',
    icon: <PostsIcon />,
    order: 16,
    menuItems: [
      {
        item: { ar: 'قائمة رئيسية', en: 'Dashboard' },
        link: path.posts.DASHBOARD,
        order: 1,
        id: 'dashboard-posts',
      },
      {
        item: {
          ar: ' جدول منشورات تويتر',
          en: 'twitter posts table',
        },
        link: path.posts.TWITTER_POSTS_TABLE,
        order: 2,
        id: 'twitter-posts-table',
      },
      {
        item: {
          ar: ' جدول منشورات يوتيوب',
          en: 'youtube posts table',
        },
        link: path.posts.YOUTUBE_POSTS_TABLE,
        order: 3,
        id: 'youtube-posts-table',
      },
      {
        item: {
          ar: 'جدول منشورات لينكدان',
          en: 'linkedin posts table',
        },
        link: path.posts.LINKEDIN_POSTS_TABLE,
        order: 6,
        id: 'linkedin-posts-table',
      },
      {
        item: {
          ar: 'جدول منشورات انستجرام',
          en: 'instagram posts table',
        },
        link: path.posts.INSTAGRAM_TABLE,
        order: 4,
        id: 'instagram-posts-table',
      },
      {
        item: {
          ar: 'جدول منشورات التيك توك',
          en: 'tiktok posts table',
        },
        link: path.posts.TIKTOK_POSTS_TABLE,
        order: 5,
        id: 'tiktok-posts-table',
      },
    ],
  },
];

export const getSideMenuState = (modules: any[]): [] => {
  const filteredModules = modules || [];
  const getDashboardLinks = () => {
    const links: any[] = sideBarItems
      .filter(
        (item: any) =>
          filteredModules?.includes(item.module) &&
          item.module !== 'ORGANIZATIONS',
      )
      .map((item: any) => ({
        item: item.title,
        link: (path as any)?.dashboard?.[item.module],
        id: (path as any)?.dashboard?.[item.module],
      }));
      
    return [
      {
        item: { ar: 'الكل', en: 'All' },
        link: path.dashboard.ALL,
      },
      ...links,
    ];
  };

  const sideMenuItems = [
    // Dashboard
    {
      module: 'DASHBOARD',
      title: { ar: 'قائمة رئيسية', en: 'Dashboard' },
      id: 'sidebar_dashboard',
      icon: <DashboardIcon />,
      menuItems: [
        {
          item: { ar: 'القائمة رئيسية', en: 'Main Dashboard' },
          id: 'all-dashboard',
          subMenu: getDashboardLinks(),
        },
      ],
    },
    ...sideBarItems,
  ];
  return addordertosidemenu(sideMenuItems) as any;
};

export const handlelocalStorageArray: FunctionComponent = (
  soretedArr: any,
  array: any,
) => {
  if (!Array.isArray(soretedArr)) return array;
  // get array from local storage add each icon
  const newArr: any[] = [];
  soretedArr?.forEach((element: any, i: number) => {
    const fullitem = array.find((item: any) => item.id === element.id);
    newArr.push({
      newTitle: element?.newTitle || null,
      order: element.order,
      ...fullitem,
      menuItems: element?.menuItems.map((secitem: any, j: number) => {
        const secondlvlFullitem = fullitem?.menuItems.find(
          (item: any) => item.id === secitem.id,
        );
        return {
          ...secitem,
          item: secondlvlFullitem?.item,
          subMenu: soretedArr[i]?.menuItems[j]?.subMenu?.map(
            (thirdlvlitem: any) => {
              const thirdlvlFullitem = secondlvlFullitem?.subMenu.find(
                (item: any) => item.id === thirdlvlitem.id,
              );

              return { ...thirdlvlitem, item: thirdlvlFullitem?.item };
            },
          ),
        };
      }),
    });
  });
  return newArr;
};
